module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pan":"Pan","rectangle_selection":"Rectangle Selection","linear_selection":"Linear Selection"},"ja":{"pan":"移動","rectangle_selection":"矩形選択","linear_selection":"線形選択"}}')
  delete Component.options._Ctor
}
